import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SzablonStronyGlownejComponent} from './core/szablony/szablon-strony-glownej/szablon-strony-glownej.component';
import { SzablonMapaComponent } from './core/szablony/szablon-mapa/szablon-mapa.component';
import { SzablonMapaInfoCmsComponent } from './core/szablony/szablon-mapa-info-cms/szablon-mapa-info-cms.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./funkcjonalnosci/strona-startowa/strona-startowa.module').then((m) => m.StronaStartowaModule),
     data: { title: 'Portal Historyczny Warszawy' }
  },
  {
    path: 'komunikat',
    loadChildren: () => import('./funkcjonalnosci/komunikaty/komunikaty.module').then((m) => m.KomunikatyModule)
  },
  {
    path: 'aktualnosci',
    component: SzablonStronyGlownejComponent,
    loadChildren: () => import('./funkcjonalnosci/aktualnosci/aktualnosci.module').then((m) => m.AktualnosciModule),
     data: { title: 'Archiwum aktualności' }
  },
  {
    path: 'mapa',
     component: SzablonMapaComponent,
    loadChildren: () => import('./funkcjonalnosci/map/map.module').then((m) => m.MapModule),
      data: { title: 'Portal Historyczny Warszawy' }
  },
  // {
  //   path: 'portal-historyczny/mapa',
  //   loadChildren: () => import('./funkcjonalnosci/map/map.module').then((m) => m.MapModule),
  //   data: { title: 'Portal Historyczny Warszawy' }
  // },
  {
    path: '**', redirectTo: ''
  }
];

/**
 * Definicja routingu dla modułu
 */
@NgModule({
  imports: [
RouterModule.forRoot(routes, {
  enableTracing: false,
})
],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
